import React, { useState } from "react";
import { siteConfig } from "../siteConfig";

const initialFormState = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

const escapeHtml = (value = "") =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const buildPayload = (formData) => ({
  userEmail: siteConfig.email,
  clientName: formData.name,
  subject: "Recon Calibration & Test Labs LLP Enquiry",
  description: `<p><strong>Name :</strong> ${escapeHtml(
    formData.name
  )}</p><p><strong>Email :</strong> ${escapeHtml(
    formData.email
  )}</p><p><strong>Mobile No :</strong> ${escapeHtml(
    formData.phone
  )}</p><p><strong>Description :</strong> ${escapeHtml(formData.message)}</p>`,
});

const EnquiryForm = ({ onSuccess, submitLabel = "Send Message" }) => {
  const [formData, setFormData] = useState(initialFormState);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const response = await fetch("https://demo.bfiinfotech.co.in/api/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(buildPayload(formData)),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      setFormData(initialFormState);

      if (typeof onSuccess === "function") {
        onSuccess(formData);
      }
    } catch (error) {
      setErrorMessage(
        "We could not submit your enquiry right now. Please call or WhatsApp us directly."
      );
      console.error("Contact form submission failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-6">
        <input
          type="text"
          name="name"
          required
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name"
          autoComplete="name"
          className="w-full rounded border border-gray-200 py-3 px-[14px] text-base text-body-color outline-none focus:border-primary focus-visible:shadow-none"
        />
      </div>
      <div className="mb-6">
        <input
          type="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
          placeholder="Your Email"
          autoComplete="email"
          className="w-full rounded border border-gray-200 py-3 px-[14px] text-base text-body-color outline-none focus:border-primary focus-visible:shadow-none"
        />
      </div>
      <div className="mb-6">
        <input
          type="tel"
          name="phone"
          required
          value={formData.phone}
          onChange={handleChange}
          placeholder="Your Phone"
          autoComplete="tel"
          className="w-full rounded border border-gray-200 py-3 px-[14px] text-base text-body-color outline-none focus:border-primary focus-visible:shadow-none"
        />
      </div>
      <div className="mb-6">
        <textarea
          rows="4"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Your Message"
          required
          className="w-full resize-none rounded border border-gray-200 py-3 px-[14px] text-base text-body-color outline-none focus:border-primary focus-visible:shadow-none"
        />
      </div>
      {errorMessage ? (
        <p className="mb-4 text-sm text-red-600">{errorMessage}</p>
      ) : null}
      <div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full rounded border border-primary bg-blue-600 p-3 text-white transition hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {isSubmitting ? "Submitting..." : submitLabel}
        </button>
      </div>
    </form>
  );
};

export default EnquiryForm;
